module.exports = __webpack_public_path__ + "static/media/brillumex-4.a57c41f1.jpg";